
import React from "react";
import { Button } from "@/components/ui/button";
import { MessageCircle } from "lucide-react";
import { trackFormTriggerClicked } from "@/lib/posthog";

interface AppointmentButtonProps {
  isScrolled: boolean;
}

const AppointmentButton: React.FC<AppointmentButtonProps> = ({ isScrolled }) => {
  const handleClick = () => {
    trackFormTriggerClicked("Discuter avec un conseiller", "header", "button");
    
    // Check if HubSpot chat is available
    if (window.HubSpotConversations?.widget) {
      const widget = window.HubSpotConversations.widget;
      
      // If chat is already open, close it then reopen
      try {
        const status = widget.status();
        if (status?.loaded) {
          widget.close();
          setTimeout(() => {
            widget.open();
          }, 100);
        } else {
          widget.open();
        }
      } catch (error) {
        // Fallback: just open the widget
        widget.open();
      }
    }
  };

  return (
    <Button
      className={`hidden md:flex font-semibold px-4 py-2 rounded-xl transition-all duration-300 ease-out transform hover:scale-105 border ${
        isScrolled 
          ? "bg-white/30 text-black border-black/20 hover:bg-white/40 hover:border-black/30" 
          : "bg-white/20 text-white border-white/30 hover:bg-white/30 hover:border-white/40"
      }`}
      onClick={handleClick}
    >
      <MessageCircle className="h-4 w-4 mr-1" />
      Discuter avec un conseiller
    </Button>
  );
};

export default AppointmentButton;
